import { 
    initializeApp 
} from "firebase/app";
import { 
    getFirestore, 
    doc, 
    setDoc, 
    serverTimestamp, 
    collection, 
    query,      
    getDocs,    
    orderBy,    
    deleteDoc, 
    updateDoc,
    addDoc,
    getDoc
} from "firebase/firestore";

// --- KONFIGURASI FIREBASE ---
const FIREBASE_CONFIG = {
  apiKey: process.env.REACT_APP_FIREBASE_KEY, 
  authDomain: process.env.REACT_APP_FIREBASE_DOMAIN || "vdvoucher.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "vdvoucher", 
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE || "vdvoucher.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER || "535315980318",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:535315980318:web:ac71d91380d51f1a7ace0f"
};

// --- INISIALISASI ---
const app = initializeApp(FIREBASE_CONFIG);
export const db = getFirestore(app);

// --- NAMA KOLEKSI ---
const DB_COLLECTION_NAME = 'extracted_vouchers'; 
const REKAPAN_COLLECTION = 'rekapan_operasional';
const AGENTS_COLLECTION = 'daftar_agen'; 
const SETTINGS_COLLECTION = 'settings'; 

// --- CONSTANTS ---
export const WEBHOOK_ID = "WH-AGENTS-UPDATE-2026"; 

/**
 * ==========================================
 * FUNGSI BROADCAST & SETTINGS
 * ==========================================
 */

export async function getBroadcastConfig() {
    try {
        const docRef = doc(db, SETTINGS_COLLECTION, "broadcast_config");
        const docSnap = await getDoc(docRef);
        return docSnap.exists() ? docSnap.data() : null;
    } catch (err) {
        console.error("Error fetching broadcast config:", err);
        return null;
    }
}

export async function updateBroadcastConfig(data) {
    try {
        const docRef = doc(db, SETTINGS_COLLECTION, "broadcast_config");
        await setDoc(docRef, {
            ...data,
            webhookId: WEBHOOK_ID,
            updatedAt: serverTimestamp()
        }, { merge: true });
        return { success: true };
    } catch (err) {
        console.error("Error updating broadcast config:", err);
        throw err;
    }
}

/**
 * ==========================================
 * FUNGSI DAFTAR AGEN (YANG HILANG)
 * ==========================================
 */

export async function getAgents() {
    try {
        const q = query(collection(db, AGENTS_COLLECTION), orderBy("name", "asc"));
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    } catch (err) {
        console.error("Error fetching agents:", err);
        throw err;
    }
}

export async function saveAgent(agentData) {
    try {
        const { id, ...data } = agentData;
        if (id && typeof id === 'string' && id.length > 15) {
            const docRef = doc(db, AGENTS_COLLECTION, id);
            await updateDoc(docRef, {
                ...data,
                lastUpdated: serverTimestamp(),
                webhookId: WEBHOOK_ID
            });
            return id;
        } else {
            const docRef = await addDoc(collection(db, AGENTS_COLLECTION), {
                ...data,
                createdAt: serverTimestamp(),
                webhookId: WEBHOOK_ID
            });
            return docRef.id;
        }
    } catch (err) {
        console.error("Error saving agent:", err);
        throw err;
    }
}

export async function deleteAgent(agentId) {
    try {
        await deleteDoc(doc(db, AGENTS_COLLECTION, agentId));
    } catch (err) {
        console.error("Error deleting agent:", err);
        throw err;
    }
}

/**
 * ==========================================
 * FUNGSI REKAPAN (YANG HILANG)
 * ==========================================
 */

export async function saveRekapData(date, data, showStatus) {
    try {
        const docRef = doc(db, REKAPAN_COLLECTION, date);
        await setDoc(docRef, { ...data, lastUpdated: serverTimestamp() }, { merge: true });
        if (showStatus) showStatus("Data tersinkronisasi", "success");
        return { success: true };
    } catch (err) {
        if (showStatus) showStatus(`Gagal: ${err.message}`, 'error');
        throw err;
    }
}

/**
 * ==========================================
 * FUNGSI VALIDATOR VOUCHER
 * ==========================================
 */

export async function saveCodesToDatabase(codes, filename, showStatus) {
    try {
        const docId = `extraction_${Date.now()}`;
        const docRef = doc(db, DB_COLLECTION_NAME, docId);
        await setDoc(docRef, {
            codes: codes,
            filename: filename,
            timestamp: serverTimestamp(),
            webhookId: WEBHOOK_ID
        });
        return { success: true, id: docId };
    } catch (err) {
        if (showStatus) showStatus(`Gagal menyimpan: ${err.message}`, 'error');
        throw err;
    }
}

export async function fetchHistory() {
    try {
        const q = query(collection(db, DB_COLLECTION_NAME), orderBy("timestamp", "desc"));
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    } catch (err) {
        console.error("Error fetching history:", err);
        throw err;
    }
}

export async function updateFilename(itemId, newFilename) {
    try {
        const docRef = doc(db, DB_COLLECTION_NAME, itemId);
        await updateDoc(docRef, { filename: newFilename.trim() });
        return { success: true };
    } catch (err) {
        console.error("Error update filename:", err);
        throw err;
    }
}

export async function deleteHistoryItem(itemId) {
    try {
        await deleteDoc(doc(db, DB_COLLECTION_NAME, itemId));
        return { success: true };
    } catch (err) {
        console.error("Error delete history:", err);
        throw err;
    }
}